export const SEARCH_QUERY = {
  REFERRAL_CODE: 'referral-code',
};
